import { createElement } from "react";
import React from "react";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { Msg } from "../App/Messages.js";
import { createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { empty, map, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { t } from "../Lang.js";
import { Auth_confirmPasswordPlaceholder, Auth_confirmPassword, Auth_newPasswordPlaceholder, Auth_newPassword, Auth_resetPasswordSuccess, Auth_resetPassword, Auth_sendResetLink, Auth_backToLogin, Auth_forgotPasswordSuccess, Auth_forgotPasswordTitle, Contact_title, Auth_switchToRegister, Auth_switchToLogin, Auth_orContinueWith, Auth_forgotPassword, Auth_loginButton, Auth_registerButton, Auth_agreeToTermsLink, Auth_agreeToTermsPrefix, Auth_passwordPlaceholder, Auth_password, Auth_emailPlaceholder, Auth_email, Auth_loginTitle, Auth_registerTitle, Auth_debugLoginButton, Auth_submitting, Auth_selectUser, Auth_debugModeBadge, Auth_debugTitle } from "../Shared/Tr.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { isEmpty, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { printf, toText } from "../fable_modules/fable-library-js.4.28.0/String.js";

function TurnstileWidget(turnstileWidgetInputProps) {
    const dispatch = turnstileWidgetInputProps.dispatch;
    useEffectWithDeps(() => {
        const widgetId = (function(id, key, cb) {
                    if (typeof turnstile !== 'undefined') {
                        return turnstile.render('#' + id, { sitekey: key, callback: cb });
                    }
                    return '';
                })("turnstile-container", "0x4AAAAAACx_qjUV1_JTYdTD", ((token) => {
            dispatch(new Msg(14, [token]));
        }));
        return {
            Dispose() {
                (function(wid) {
                        if (typeof turnstile !== 'undefined' && wid) {
                            try { turnstile.remove(wid); } catch(_) {}
                        }
                    })(widgetId);
            },
        };
    }, []);
    return createElement("div", {
        id: "turnstile-container",
        className: "turnstile-widget",
    });
}

function debugLoginView(form, dispatch) {
    let elems_4, elems_3;
    return createElement("div", createObj(ofArray([["className", "auth-container"], (elems_4 = [createElement("div", createObj(ofArray([["className", "card"], (elems_3 = toList(delay(() => append(singleton(createElement("h2", {
        children: t(Auth_debugTitle),
    })), delay(() => append(singleton(createElement("div", {
        className: "debug-badge",
        children: t(Auth_debugModeBadge),
    })), delay(() => {
        let matchValue;
        return append((matchValue = form.Error, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement("div", {
            className: "error-message",
            children: matchValue,
        }))), delay(() => {
            let elems_1, elems;
            return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_1 = [createElement("label", {
                children: t(Auth_selectUser),
            }), createElement("select", createObj(ofArray([["className", "form-input"], ["value", form.SelectedUserId], ["onChange", (ev) => {
                dispatch(new Msg(18, [ev.target.value]));
            }], ["disabled", form.IsSubmitting], (elems = toList(delay(() => map((user) => createElement("option", {
                value: user.Id,
                children: `${user.Name} (${user.Email})`,
            }), form.DebugUsers))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_2;
                return singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_2 = [createElement("button", {
                    className: "btn btn-primary",
                    style: {
                        width: 100 + "%",
                    },
                    disabled: form.IsSubmitting ? true : (form.SelectedUserId === ""),
                    children: form.IsSubmitting ? t(Auth_submitting) : t(Auth_debugLoginButton),
                    onClick: (_arg) => {
                        if (!form.IsSubmitting) {
                            dispatch(new Msg(19, []));
                        }
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            }));
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function normalLoginView(form, dispatch) {
    let elems_12, elems_11;
    const isRegister = form.IsRegisterMode;
    return createElement("div", createObj(ofArray([["className", "auth-container"], (elems_12 = [createElement("div", createObj(ofArray([["className", "card"], (elems_11 = toList(delay(() => append(singleton(createElement("h2", {
        children: isRegister ? t(Auth_registerTitle) : t(Auth_loginTitle),
    })), delay(() => {
        let matchValue;
        return append((matchValue = form.Error, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement("div", {
            className: "error-message",
            children: matchValue,
        }))), delay(() => {
            let elems;
            return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems = [createElement("label", {
                children: t(Auth_email),
            }), createElement("input", {
                className: "form-input",
                type: "email",
                placeholder: t(Auth_emailPlaceholder),
                value: form.Email,
                onChange: (ev) => {
                    dispatch(new Msg(9, [ev.target.value]));
                },
                disabled: form.IsSubmitting,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                let elems_1;
                return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_1 = [createElement("label", {
                    children: t(Auth_password),
                }), createElement("input", {
                    className: "form-input",
                    type: "password",
                    placeholder: t(Auth_passwordPlaceholder),
                    value: form.Password,
                    onChange: (ev_1) => {
                        dispatch(new Msg(10, [ev_1.target.value]));
                    },
                    disabled: form.IsSubmitting,
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    let elems_4, elems_3, elems_2;
                    return append(isRegister ? singleton(createElement("div", createObj(ofArray([["className", "form-group tos-group"], (elems_4 = [createElement("label", createObj(ofArray([["className", "tos-label"], (elems_3 = [createElement("input", {
                        type: "checkbox",
                        checked: form.AgreeToTerms,
                        onChange: (ev_2) => {
                            const _arg = ev_2.target.checked;
                            dispatch(new Msg(13, []));
                        },
                        disabled: form.IsSubmitting,
                    }), createElement("span", createObj(singleton_1((elems_2 = [t(Auth_agreeToTermsPrefix), createElement("a", {
                        href: "/terms.html",
                        target: "_blank",
                        children: t(Auth_agreeToTermsLink),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty(), delay(() => append(isRegister ? singleton(createElement(TurnstileWidget, {
                        dispatch: dispatch,
                    })) : empty(), delay(() => {
                        let elems_5;
                        return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_5 = [createElement("button", {
                            className: "btn btn-primary",
                            style: {
                                width: 100 + "%",
                            },
                            disabled: form.IsSubmitting ? true : (isRegister && (!form.AgreeToTerms ? true : (form.TurnstileToken == null))),
                            children: form.IsSubmitting ? t(Auth_submitting) : (isRegister ? t(Auth_registerButton) : t(Auth_loginButton)),
                            onClick: (_arg_1) => {
                                if (!form.IsSubmitting) {
                                    dispatch(isRegister ? (new Msg(3, [])) : (new Msg(2, [])));
                                }
                            },
                        })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                            let elems_6;
                            return append(!isRegister ? singleton(createElement("div", createObj(ofArray([["className", "auth-toggle"], ["style", {
                                marginBottom: 0.5 + "rem",
                            }], (elems_6 = [createElement("a", {
                                href: "#/forgot-password",
                                className: "btn-link",
                                children: t(Auth_forgotPassword),
                            })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : empty(), delay(() => {
                                let elems_7;
                                return append(!isEmpty(form.ExternalProviders) ? append(singleton(createElement("div", createObj(ofArray([["className", "social-login-divider"], (elems_7 = [createElement("span", {
                                    children: t(Auth_orContinueWith),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                                    let elems_8;
                                    return singleton(createElement("div", createObj(ofArray([["className", "social-login-buttons"], (elems_8 = toList(delay(() => map((provider) => createElement("button", {
                                        className: toText(printf("btn btn-social btn-social-%s"))(provider.Id),
                                        children: provider.Name,
                                        disabled: form.IsSubmitting,
                                        onClick: (_arg_2) => {
                                            dispatch(new Msg(22, [provider.Id]));
                                        },
                                    }), form.ExternalProviders))), ["children", reactApi.Children.toArray(Array.from(elems_8))])]))));
                                })) : empty(), delay(() => {
                                    let elems_9;
                                    return append(singleton(createElement("div", createObj(ofArray([["className", "auth-toggle"], (elems_9 = [createElement("button", {
                                        className: "btn-link",
                                        children: isRegister ? t(Auth_switchToLogin) : t(Auth_switchToRegister),
                                        onClick: (_arg_3) => {
                                            dispatch(new Msg(12, []));
                                        },
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => {
                                        let elems_10;
                                        return singleton(createElement("div", createObj(ofArray([["className", "auth-toggle"], (elems_10 = [createElement("a", {
                                            href: "#/contact",
                                            className: "btn-link",
                                            children: t(Contact_title),
                                        })], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))));
                                    }));
                                }));
                            }));
                        }));
                    }))));
                }));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])));
}

export function view(model, dispatch) {
    const form = model.LoginForm;
    if (form.IsDebugMode) {
        return debugLoginView(form, dispatch);
    }
    else {
        return normalLoginView(form, dispatch);
    }
}

export function forgotPasswordView(model, dispatch) {
    let elems_5, elems_4;
    const form = model.ForgotPasswordForm;
    return createElement("div", createObj(ofArray([["className", "auth-container"], (elems_5 = [createElement("div", createObj(ofArray([["className", "card"], (elems_4 = toList(delay(() => append(singleton(createElement("h2", {
        children: t(Auth_forgotPasswordTitle),
    })), delay(() => {
        let matchValue;
        return form.IsSubmitted ? append(singleton(createElement("div", {
            className: "success-message",
            children: t(Auth_forgotPasswordSuccess),
        })), delay(() => {
            let elems;
            return singleton(createElement("div", createObj(ofArray([["className", "auth-toggle"], (elems = [createElement("a", {
                href: "#/login",
                className: "btn-link",
                children: t(Auth_backToLogin),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        })) : append((matchValue = form.Error, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement("div", {
            className: "error-message",
            children: matchValue,
        }))), delay(() => {
            let elems_1;
            return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_1 = [createElement("label", {
                children: t(Auth_email),
            }), createElement("input", {
                className: "form-input",
                type: "email",
                placeholder: t(Auth_emailPlaceholder),
                value: form.Email,
                onChange: (ev) => {
                    dispatch(new Msg(23, [ev.target.value]));
                },
                disabled: form.IsSubmitting,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_2;
                return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_2 = [createElement("button", {
                    className: "btn btn-primary",
                    style: {
                        width: 100 + "%",
                    },
                    disabled: form.IsSubmitting ? true : (form.Email === ""),
                    children: form.IsSubmitting ? t(Auth_submitting) : t(Auth_sendResetLink),
                    onClick: (_arg) => {
                        if (!form.IsSubmitting) {
                            dispatch(new Msg(24, []));
                        }
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                    let elems_3;
                    return singleton(createElement("div", createObj(ofArray([["className", "auth-toggle"], (elems_3 = [createElement("a", {
                        href: "#/login",
                        className: "btn-link",
                        children: t(Auth_backToLogin),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                }));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export function resetPasswordView(model, dispatch) {
    let elems_6, elems_5;
    const form = model.ResetPasswordForm;
    return createElement("div", createObj(ofArray([["className", "auth-container"], (elems_6 = [createElement("div", createObj(ofArray([["className", "card"], (elems_5 = toList(delay(() => append(singleton(createElement("h2", {
        children: t(Auth_resetPassword),
    })), delay(() => {
        let matchValue;
        return form.IsCompleted ? append(singleton(createElement("div", {
            className: "success-message",
            children: t(Auth_resetPasswordSuccess),
        })), delay(() => {
            let elems;
            return singleton(createElement("div", createObj(ofArray([["className", "auth-toggle"], (elems = [createElement("a", {
                href: "#/login",
                className: "btn-link",
                children: t(Auth_backToLogin),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        })) : append((matchValue = form.Error, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement("div", {
            className: "error-message",
            children: matchValue,
        }))), delay(() => {
            let elems_1;
            return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_1 = [createElement("label", {
                children: t(Auth_newPassword),
            }), createElement("input", {
                className: "form-input",
                type: "password",
                placeholder: t(Auth_newPasswordPlaceholder),
                value: form.NewPassword,
                onChange: (ev) => {
                    dispatch(new Msg(27, [ev.target.value]));
                },
                disabled: form.IsSubmitting,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_2;
                return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_2 = [createElement("label", {
                    children: t(Auth_confirmPassword),
                }), createElement("input", {
                    className: "form-input",
                    type: "password",
                    placeholder: t(Auth_confirmPasswordPlaceholder),
                    value: form.ConfirmPassword,
                    onChange: (ev_1) => {
                        dispatch(new Msg(28, [ev_1.target.value]));
                    },
                    disabled: form.IsSubmitting,
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                    let elems_3;
                    return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_3 = [createElement("button", {
                        className: "btn btn-primary",
                        style: {
                            width: 100 + "%",
                        },
                        disabled: (form.IsSubmitting ? true : (form.NewPassword === "")) ? true : (form.ConfirmPassword === ""),
                        children: form.IsSubmitting ? t(Auth_submitting) : t(Auth_resetPassword),
                        onClick: (_arg) => {
                            if (!form.IsSubmitting) {
                                dispatch(new Msg(29, []));
                            }
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                        let elems_4;
                        return singleton(createElement("div", createObj(ofArray([["className", "auth-toggle"], (elems_4 = [createElement("a", {
                            href: "#/login",
                            className: "btn-link",
                            children: t(Auth_backToLogin),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                    }));
                }));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

